import React, { Component } from 'react';
import MemberItem from './MemberItem';
import uuid from './../../../../../helpers/uuid';

class MemberList extends Component {
    render() {
        return (
            <div className="container">
                <section className="row" id="top-of-list">
                    { this.props.members.map( ( member, index ) => <MemberItem key={ uuid() } index={ index } member={ member }  /> ) }
                </section>
            </div>
        );
    };
}

export default MemberList;



// WEBPACK FOOTER //
// src/client/components/site/features/members/pages/MemberList.js